module.exports = __webpack_public_path__ + "media/assets/satellite-ffa77aaa55b9c203e19f29c45597fb41.svg";